<template>
  <div v-if="action && parents">
    <h1>Action</h1>
    <v-btn :to="computedRuleLink" v-if="computedRuleLink">
      <v-icon>chevron_left</v-icon>Rule
    </v-btn>
    <v-form ref="formAction" v-model="valid" lazy-validation>
      <v-select
        label="Type"
        v-model="action.actionType"
        :items="actionTypes"
        item-value="id"
        item-text="body"
        :rules="valueRules"
        outline
      />
      <v-select
        label="Description"
        v-model="action.descriptionid"
        :items="descriptions"
        item-value="id"
        item-text="body"
        :rules="valueRules"
        outline
      />
      <h3>Secondary</h3>
      <v-select
        label="Secondary type"
        v-model="action.secondaryType"
        :items="secondaryTypes"
        item-value="id"
        item-text="body"
        outline
      >
        <template slot="append-outer" v-if="action.secondaryType">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <a @click="action.secondaryType = null" v-on="on">
                <v-icon>clear</v-icon>
              </a>
            </template>
            <span>Remove secondary type</span>
          </v-tooltip>
        </template>
      </v-select>
      <v-autocomplete
        label="Previous"
        v-model="action.secondaryPrevious.secondaryid"
        :items="secondaries"
        :search-input.sync="secondary"
        item-text="body"
        item-value="id"
        outline
        :rules="valueRules"
        v-if="action.secondaryType == 'secondaryPrevious'"
      />
      <v-select
        label="Question"
        v-model="action.secondaryQuestion.questionid"
        :items="computedQuestions3"
        item-value="id"
        item-text="body"
        :rules="valueRules"
        v-if="action.secondaryType == 'secondaryQuestion'"
        outline
      />
      <v-select
        label="Question"
        v-model="action.secondaryPercentage.questionid"
        :items="computedQuestions1"
        item-value="id"
        item-text="body"
        :rules="valueRules"
        v-if="action.secondaryType == 'secondaryPercentage'"
        outline
      />
      <v-select
        label="Scale percentage type"
        v-model="action.secondaryPercentage.scalepercentagetypeid"
        :items="scalePercentageTypes"
        item-value="id"
        item-text="name"
        :rules="valueRules"
        v-if="action.secondaryType == 'secondaryPercentage'"
        outline
      />
      <v-text-field
        type="number"
        label="Surcharge"
        v-model="action.secondaryPercentage.surcharge"
        :rules="valueRules"
        v-if="action.secondaryType == 'secondaryPercentage'"
        outline
      />
      <v-select
        label="Parameter type"
        v-model="action.secondaryParameterPercentage.parametertypeid"
        :items="parameterTypes"
        item-value="id"
        item-text="body"
        :rules="valueRules"
        v-if="action.secondaryType == 'secondaryParameterPercentage'"
        outline
      />
      <h3>Fee</h3>
      <v-select
        label="Calc type"
        v-model="action.calcType"
        :items="calcTypes"
        item-value="id"
        item-text="body"
        outline
      >
        <template slot="append-outer" v-if="action.calcType">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <a @click="action.calcType = null" v-on="on">
                <v-icon>clear</v-icon>
              </a>
            </template>
            <span>Remove calc type</span>
          </v-tooltip>
        </template>
      </v-select>
      <v-select
        label="Parameter type"
        v-model="action.calcFixed.parametertypeid"
        :items="parameterTypes"
        item-value="id"
        item-text="body"
        :rules="valueRules"
        v-if="action.calcType == 'calcFixed'"
        outline
      />
      <v-select
        label="Question"
        v-model="action.calcScaleFee.questionid"
        :items="computedQuestions1"
        item-value="id"
        item-text="body"
        :rules="valueRules"
        v-if="action.calcType == 'calcScaleFee'"
        outline
      />
      <v-select
        label="Scale fee type"
        v-model="action.calcScaleFee.scalefeetypeid"
        :items="scaleFeeTypes"
        item-value="id"
        item-text="name"
        :rules="valueRules"
        v-if="action.calcType == 'calcScaleFee'"
        outline
      />
      <v-select
        label="Question"
        v-model="action.calcScalePercentage.questionid"
        :items="computedQuestions1"
        item-value="id"
        item-text="body"
        :rules="valueRules"
        v-if="action.calcType == 'calcScalePercentage'"
        outline
      />
      <v-select
        label="Scale percentage type"
        v-model="action.calcScalePercentage.scalepercentagetypeid"
        :items="scalePercentageTypes"
        item-value="id"
        item-text="name"
        :rules="valueRules"
        v-if="action.calcType == 'calcScalePercentage'"
        outline
      />
      <v-text-field
        type="number"
        label="Surcharge"
        v-model="action.calcScalePercentage.surcharge"
        :rules="valueRules"
        v-if="action.calcType == 'calcScalePercentage'"
        outline
      />
      <v-select
        label="Question"
        v-model="action.calcUser.questionid"
        :items="computedQuestions1"
        item-value="id"
        item-text="body"
        :rules="valueRules"
        v-if="action.calcType == 'calcUser'"
        outline
      />
      <v-select
        label="Question"
        v-model="action.calcMultiply.questionid"
        :items="computedQuestions3"
        item-value="id"
        item-text="body"
        :rules="valueRules"
        v-if="action.calcType == 'calcMultiply'"
        outline
      />
      <v-select
        label="Parameter type"
        v-model="action.calcMultiply.parametertypeid"
        :items="parameterTypes"
        item-value="id"
        item-text="body"
        :rules="valueRules"
        v-if="action.calcType == 'calcMultiply'"
        outline
      />
      <v-select
        label="Parameter type"
        v-model="action.calcFeePercentage.parametertypeid"
        :items="parameterTypes"
        item-value="id"
        item-text="body"
        :rules="valueRules"
        v-if="action.calcType == 'calcFeePercentage'"
        outline
      />
      <v-btn @click="saveAction"> <v-icon>save</v-icon>Save </v-btn>
      <v-btn :to="computedRuleLink">Cancel</v-btn>
    </v-form>
  </div>
</template>

<script>
import { convertListOfObjectsToMap } from "@/util/helpers";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Action",
  metaInfo() {
    return {
      title: "Action",
      titleTemplate: "%s - Sales - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  computed: {
    computedRuleLink() {
      if (!this.computedRuleid) {
        return undefined;
      }
      return { name: "quoteRule", params: { id: this.computedRuleid } };
    },
    computedRuleid() {
      if (this.$route.query.ruleid) {
        return this.$route.query.ruleid;
      }
      if (!this.action) {
        return undefined;
      }
      return this.action.ruleid;
    },
    computedQuestions1() {
      if (!this.computedQuestions) {
        return undefined;
      }
      return this.computedQuestions.filter(
        (q) => !q.locked && q.questionType.scale
      );
    },
    computedQuestions3() {
      if (!this.computedQuestions) {
        return undefined;
      }
      return this.computedQuestions.filter(
        (q) =>
          !q.locked &&
          (q.questionType.multiply || q.questionType.name == "mortgage amount")
      );
    },
    computedQuestions() {
      if (!this.parents || !this.parents.questions) {
        return undefined;
      }
      if (!this.computedQuestionTypes) {
        return undefined;
      }
      return this.parents.questions.map((q) => {
        const questionType = this.computedQuestionTypes[q.questiontypeid];
        return { ...q, questionType };
      });
    },
    computedQuestionTypes() {
      if (!this.questionTypes) {
        return undefined;
      }
      return convertListOfObjectsToMap(this.questionTypes, "id");
    }
  },
  data() {
    return {
      action: null,
      actionTypes: [
        { id: "discount", body: "Discount" },
        { id: "item", body: "Item" },
        { id: "note", body: "Note" },
        { id: "title", body: "Title" }
      ],
      descriptions: null,
      secondaryTypes: [
        { id: "secondaryParameterPercentage", body: "Parameter percentage" },
        { id: "secondaryPercentage", body: "Percentage" },
        { id: "secondaryPrevious", body: "Previous" },
        { id: "secondaryQuestion", body: "Question" }
      ],
      calcTypes: [
        { id: "calcFixed", body: "Fixed fee" },
        { id: "calcMultiply", body: "Multiply" },
        { id: "calcFeePercentage", body: "Fee percentage" },
        { id: "calcScaleFee", body: "Scale fee" },
        { id: "calcScalePercentage", body: "Scale percentage" },
        { id: "calcUser", body: "User value" }
      ],
      secondaries: [],
      secondary: null,
      timerId: null,
      parents: null,
      questionTypes: null,
      scaleFeeTypes: null,
      scalePercentageTypes: null,
      parameterTypes: null,
      valid: false,
      valueRules: [(v) => v != undefined || "Value is required"]
    };
  },
  methods: {
    async fetchAction() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/actions/${this.$route.params.id}/full`
      );
      // console.log(response.data);
      this.action = response.data;
    },
    async fetchSecondary() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/actions/${this.$route.params.id}/secondary`
      );
      // console.log(response.data);
      this.secondaries.push(response.data);
    },
    async fetchDescriptions() {
      const response = await nbmlaw.get(`/cors/admin/sales/descriptions`);
      // console.log(response.data)
      this.descriptions = response.data;
    },
    completeSecondary() {
      // debounce
      clearTimeout(this.timerId);
      if (!this.secondary) {
        this.secondaries = [];
        return;
      }
      this.timerId = setTimeout(() => {
        // console.log(value)
        this.fetchSecondaries();
      }, 400);
    },
    async fetchSecondaries() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/secondaries/complete`,
        {
          params: { value: this.secondary }
        }
      );
      // console.log(response.data);
      this.secondaries = response.data;
    },
    async fetchActionParents() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/actions/${this.$route.params.id}/parents`
      );
      // console.log(response.data);
      this.parents = response.data;
    },
    async fetchRuleParents() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/rules/${this.$route.query.ruleid}/parents`
      );
      // console.log(response.data);
      this.parents = response.data;
    },
    async fetchQuestionTypes() {
      const response = await nbmlaw.get(`/cors/admin/sales/questionTypes`);
      // console.log(response.data);
      this.questionTypes = response.data;
    },
    async fetchScaleFeeTypes() {
      const response = await nbmlaw.get(`/cors/admin/sales/scaleFeeTypes`);
      // console.log(response.data);
      this.scaleFeeTypes = response.data;
    },
    async fetchScalePercentageTypes() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/scalePercentageTypes`
      );
      // console.log(response.data);
      this.scalePercentageTypes = response.data;
    },
    async fetchParameterTypes() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/prices/system/parameterTypes/list`
      );
      // console.log(response.data);
      this.parameterTypes = response.data;
    },
    saveAction() {
      if (this.$refs.formAction.validate()) {
        if (this.$route.params.id) {
          this.updateAction();
        } else {
          this.createAction();
        }
      }
    },
    async createAction() {
      await nbmlaw.post(
        `/cors/admin/sales/rules/${this.$route.query.ruleid}/actions`,
        this.action
      );
      // console.log(response.data);
      this.$router.push(this.computedRuleLink);
    },
    async updateAction() {
      await nbmlaw.put(
        `/cors/admin/sales/actions/${this.$route.params.id}/full`,
        this.action
      );
      // console.log(response.data);
      this.$router.push(this.computedRuleLink);
    },
    update() {
      if (this.$route.params.id) {
        this.fetchAction();
        this.fetchSecondary();
        this.fetchActionParents();
      } else {
        this.fetchRuleParents();
      }
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        this.update();
      }
    },
    parents: {
      handler() {
        if (!this.$route.params.id) {
          this.action = {
            actionType: "item",
            descriptionid: null,
            secondaryType: null,
            secondaryPrevious: {},
            secondaryQuestion: {},
            secondaryPercentage: {},
            secondaryParameterPercentage: {},
            calcType: null,
            calcFixed: {},
            calcScaleFee: {},
            calcScalePercentage: {},
            calcUser: {},
            calcMultiply: {},
            calcFeePercentage: {}
          };
        }
      }
    },
    secondary: {
      immediate: true,
      handler() {
        this.completeSecondary();
      }
    }
  },
  created() {
    this.fetchDescriptions();
    this.fetchQuestionTypes();
    this.fetchScaleFeeTypes();
    this.fetchScalePercentageTypes();
    this.fetchParameterTypes();
  }
};
</script>